import message from './message'

export let modalVM
let modals = {
  message,
}
export function getVM() {
  return modalVM
}
export function setModals(obj = {}) {
  modals = {
    ...modals,
    ...obj,
  }
  // set modal id
  Object.keys(modals).forEach(key => {
    const comp = modals[key]
    if (!comp.props || !comp.props.id) {
      comp.props = comp.props || {}
      comp.props.id = { type: String, default: key }
    }
  })
}

export default {
  name: 'modal-container',
  inheritAttrs: false,
  data() {
    return {
      list: [],
    }
  },
  beforeCreate() {
    modalVM = this
  },

  render(h) {
    return h('div', {
      attrs: {
        id: 'modal-container',
      },
      class: 'modal-container'
    }, this.list.map((mod, index) => {
      const id = mod.id || mod.name
      let comp = modals[id]
      if (!comp) {
        comp = 'div'
      }
      return h(comp, { props: mod, key: id + '-' + index, style: {
        zIndex: index,
      } })
    }))
  }
}